import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.81 5.089a.25.25 0 0 1 .351-.03l3.25 2.75.017.015a.25.25 0 0 1-.031.38L9.161 10.94a.25.25 0 0 1-.322-.382l2.728-2.308H3.5a.25.25 0 0 1 0-.5h8.068l-2.73-2.31a.25.25 0 0 1-.029-.352",
		clipRule: "evenodd"
	})
});
export default SvgArrowRight;
